import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material'
import React from 'react'
import { checkboxModel } from '../../../Models'

const CheckedIcon = ({ disabled }: { disabled?: boolean }) => {
  const opacity = disabled ? 0.5 : 1
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ opacity }}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <rect x='0.5' y='0.5' width='15' height='15' rx='4.5' fill='#402080' stroke='#402080' />
      <g clipPath='url(#clip0_19292_125068)'>
        <path d='M2 7.5L6 11.5L14 4' stroke='white' strokeWidth='1.5' />
      </g>
      <defs>
        <clipPath id='clip0_19292_125068'>
          <rect x='2' y='2' width='12' height='12' rx='5' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

const UnCheckedIcon = ({ disabled }: { disabled?: boolean }) => {
  const opacity = disabled ? 0.5 : 1

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ opacity }}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <rect x='0.5' y='0.5' width='15' height='15' rx='4.5' fill='white' stroke='#98A1AE' />
    </svg>
  )
}

const MUICheckbox: React.FC<checkboxModel> = ({
  id,
  label,
  checked,
  disabled,
  size = 'medium',
  handleChange,
  labelPlacement = 'end',
  required = false,
  name = '',
  error = {},
  dataTestId,
  sx,
}: checkboxModel) => {
  return (
    <FormControl error={!!error?.[name]}>
      <FormControlLabel
        sx={{ display: 'flex', alignItems: 'center', margin: 0 }}
        disabled={disabled}
        labelPlacement={labelPlacement}
        checked={checked}
        control={
          <Checkbox
            data-testid={dataTestId ?? id ?? label}
            checkedIcon={<CheckedIcon disabled={disabled} />}
            icon={<UnCheckedIcon disabled={disabled} />}
            onChange={handleChange}
            checked={checked}
            disabled={disabled}
            size={size}
            inputProps={{ id: name }}
            sx={{
              ...sx,
            }}
          />
        }
        label={
          label ? (
            <span style={{ marginLeft: '8px' }}>
              {label}
              {required && <span style={{ color: '#D4351C' }}>*</span>}
            </span>
          ) : null
        }
      />
      {!!error?.[name] && <FormHelperText>{error?.[name]?.message}</FormHelperText>}
    </FormControl>
  )
}

export default MUICheckbox
